import { Link2, Loader2, X } from 'lucide-react';
import { Button } from '../components/atoms/Button';

interface Props {
  /** Display name of the detected draft (falls back to a generic phrase). */
  draftName: string | null;
  busy?: boolean;
  onLink: () => void;
  onDismiss: () => void;
}

/**
 * "We detected this document came from NyayAssist — link it to the chat?"
 * banner. Shown on plugin mount when the current Word document carries a
 * provenance stamp but isn't yet linked to a chat (and the user hasn't
 * already dismissed this specific chat).
 */
export function AskToLinkBanner({ draftName, busy, onLink, onDismiss }: Props): JSX.Element {
  return (
    <div className="flex items-start gap-2 px-3 py-2 bg-primary/5 border-b border-primary/20 text-[11px] text-foreground/80">
      <Link2 className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-primary" />
      <div className="flex-1 min-w-0">
        <div className="font-medium">
          We detected this document came from NyayAssist.
        </div>
        <div className="text-[10px] text-muted-foreground mt-0.5 leading-snug">
          Link this session to{draftName ? <> draft <span className="font-medium">{draftName}</span></> : ' its chat'} to sync edits and continue the conversation.
        </div>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        <Button
          variant="default"
          size="sm"
          className="h-6 text-[10px] gap-1"
          onClick={onLink}
          disabled={busy}
        >
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Link2 className="w-3 h-3" />}
          Link
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          onClick={onDismiss}
          disabled={busy}
          title="Not now"
        >
          <X className="w-3 h-3" />
        </Button>
      </div>
    </div>
  );
}
